/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaches_Page_After_BodyInputs */

const en_coaches_page_after_body = /** @type {(inputs: Coaches_Page_After_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your training plan, diet and progress wait when you sign in, and you book the next visit in one tap.`)
};

const pl_coaches_page_after_body = /** @type {(inputs: Coaches_Page_After_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan treningowy, dieta i postępy czekają po zalogowaniu, a kolejną wizytę rezerwujesz jednym dotknięciem.`)
};

/**
* | output |
* | --- |
* | "Your training plan, diet and progress wait when you sign in, and you book the next visit in one tap." |
*
* @param {Coaches_Page_After_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const coaches_page_after_body = /** @type {((inputs?: Coaches_Page_After_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaches_Page_After_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_coaches_page_after_body(inputs)
	return en_coaches_page_after_body(inputs)
});